import React from "react";
import { Route } from "react-router-dom";
import Placement from "../pages/Placement";
import PlacementCell from "../page_content/PlacementSection/placement_cell/PlacementCell";
import PlacementTeam from "../page_content/PlacementSection/placement_team/PlacementTeam";
import Training from "../page_content/PlacementSection/training/Training";
import MOU from "../page_content/PlacementSection/MOU/MOU";
import Recruiters from "../page_content/PlacementSection/recruiters/Recruiters";
import Statistics from "../page_content/PlacementSection/statistics/Statistics";
import SampleCV from "../page_content/PlacementSection/sample_cv/SampleCV";

export const PlacementRoutes = (
  <Route path="placement" element={<Placement />}>
    <Route path="placement-cell" element={<PlacementCell />} />
    <Route path="placement-team" element={<PlacementTeam />} />
    <Route path="placement-training" element={<Training />} />
     <Route path="mou" element={<MOU />} />
    <Route path="top-recruiters" element={<Recruiters />} />
    <Route path="placement-statistics" element={<Statistics />} />
    <Route path="sample-cv" element={<SampleCV />} />
  </Route>
);




